import { ResourceCodeEnums } from "@/api/dmp_common/interface";
import { NoticeBarProps } from "@ad/anq-ui/lib/carousel-noticebar";
import {
  BrandFcpa,
  MoneyYuan,
  NormalIntegrate,
  NormalTeam,
  NormalUser,
  NormalSearchDataAnalysis,
  NormalRanking,
  MaterialShopping,
} from "src/Icons";

export interface MenuItem {
  /** 这个字段展示在url上面, 并且是权限控制对应的资源码 */
  name?: ResourceCodeEnums;
  title?: string;
  /** 是否使用默认的title, 就是一个大大的标题, true的话右侧或者其他位置的工具可以通过绝对定位安排 */
  useDefaultTitle?: boolean;
  /** 菜单项对应的子页面, 比如 投放数据->活动/计划页面; 推广追踪报告->报告详情页面; 会根据这个字段在子页面匹配对应的菜单项 */
  childrenPage?: string[];
  /** 是否一直展示; 默认为false, 根据name和后端的resourceAuthList判断是否展示 */
  show?: boolean;
  notice?: NoticeBarProps;
}

export interface MenuGroupItem {
  menuItemList: MenuItem[];
  /** menuGroup的补充权限校验码: 一般情况下, menuItem单独设置resourceCode, 并由后端控制是否展示; 如果需要menu组级别的控制, 则设置该字段, 同时忽略该组下的所有menuItem的权限 */
  permissionCode?: ResourceCodeEnums;
  /** menu组的名称, 不可点击 */
  group?: string;
  icon?: React.ReactNode;
}

/**
 * 不同的导航对应的不同的菜单组
 * 需要注意, 这里不能出现重复的菜单项
 */
export const navigationMenuGroupMap: {
  [key in ResourceCodeEnums]?: MenuGroupItem[];
} = {
  [ResourceCodeEnums.CROWD]: [
    {
      group: "资产分析",
      icon: <BrandFcpa />,
      menuItemList: [
        {
          title: "人群分布",
          name: ResourceCodeEnums.CROWD_DISTRIBUTE,
          useDefaultTitle: true,
          notice: {
            content:
              "店铺视角人群分布数据（包括认知、兴趣、购买、忠诚），将于 2024 年 1 月 23 日调整计算口径。调整后，数据可能会发生变化，请商家以平台的最新口径数据为准。",
            type: "info",
            global: false,
            closable: true,
          },
        },
        {
          title: "人群流转",
          name: ResourceCodeEnums.CROWD_TRANS,
          useDefaultTitle: true,
        },
        {
          title: "人群透视",
          name: ResourceCodeEnums.CROWD_PERSPECTIVE,
          useDefaultTitle: true,
        },
        {
          title: "店铺人群",
          name: ResourceCodeEnums.MALL_CROWD_DISTRIBUTE,
          useDefaultTitle: true,
        },
        {
          title: "商品人群",
          name: ResourceCodeEnums.GOODS_CROWD_DISTRIBUTE,
          useDefaultTitle: true,
        },
        {
          name: ResourceCodeEnums.RFM,
          title: "RFM 分析",
          useDefaultTitle: true,
        },
        {
          name: ResourceCodeEnums.CROWD_TRACE,
          title: "人群追踪",
          childrenPage: ["trace_report"],
        },
      ],
    },
    {
      group: "人群管理",
      icon: <NormalTeam />,
      menuItemList: [
        {
          title: "自定义人群",
          name: ResourceCodeEnums.CUSTOM_LABEL,
          useDefaultTitle: true,
        },
        {
          title: "旗下店铺人群",
          name: ResourceCodeEnums.MALL_LABEL,
          useDefaultTitle: true,
        },
        {
          title: "授权人群",
          name: ResourceCodeEnums.AUTH_LABEL,
          useDefaultTitle: true,
        },
        {
          title: "官方人群",
          name: ResourceCodeEnums.OFFICIAL_LABEL,
          useDefaultTitle: true,
        },
        {
          title: "人群广场",
          name: ResourceCodeEnums.LABEL_SQUARE,
          useDefaultTitle: true,
        },
      ],
    },
  ],
  [ResourceCodeEnums.BUSINESS]: [
    {
      group: "生意数据",
      icon: <MoneyYuan />,
      menuItemList: [
        {
          title: "交易数据",
          name: ResourceCodeEnums.GMV_OVERVIEW,
        },
        {
          title: "交易构成",
          name: ResourceCodeEnums.GMV_DETAIL,
        },
      ],
    },
    {
      group: "商品",
      icon: <MaterialShopping />,
      menuItemList: [
        {
          title: "商品监控",
          name: ResourceCodeEnums.GOODS_MONITOR,
          useDefaultTitle: true,
        },
      ],
    },
  ],
  [ResourceCodeEnums.ACTIVITY_PROMOTION]: [
    {
      group: "推广概况",
      icon: <NormalIntegrate />,
      menuItemList: [
        {
          title: "推广花费",
          name: ResourceCodeEnums.MARKETING_DATA,
        },
      ],
    },
    {
      group: "品牌推广",
      icon: <NormalIntegrate />,
      menuItemList: [
        {
          title: "投放数据",
          name: ResourceCodeEnums.BRAND_DATA,
        },
        // 暂时不能上线
        // {
        //   title: "拉新分析",
        //   name: ResourceCodeEnums.RCT_ANALYSIS,
        //   useDefaultTitle: true,
        // },
        {
          title: "推广追踪报告",
          name: ResourceCodeEnums.PROMO_TRACE,
          childrenPage: ["report"],
        },
      ],
    },
  ],
  [ResourceCodeEnums.MARKET_INSIGHT]: [
    {
      group: "市场洞察",
      icon: <NormalRanking />,
      menuItemList: [
        {
          title: "行业趋势",
          name: ResourceCodeEnums.INDUSTRY_TREND,
          useDefaultTitle: true,
        },
        {
          title: "市场渗透",
          name: ResourceCodeEnums.MARKET_PENETRATION,
          useDefaultTitle: true,
        },
        {
          title: "品牌榜单",
          name: ResourceCodeEnums.BRAND_RANK,
        },
        {
          title: "品牌热度指数",
          name: ResourceCodeEnums.BRAND_HEAT_INDEX,
          useDefaultTitle: true,
        },
        {
          title: "人群关联洞察",
          name: ResourceCodeEnums.CROWD_RELEVANCE,
          useDefaultTitle: true,
        },
      ],
    },
    {
      group: "搜索分析",
      icon: <NormalSearchDataAnalysis />,
      menuItemList: [
        {
          title: "搜索流量分析",
          name: ResourceCodeEnums.FLOW_ANALYSIS,
        },
      ],
    },
  ],
  [ResourceCodeEnums.ACCOUNT_MANAGEMENT]: [
    {
      group: "账户",
      icon: <NormalUser />,
      menuItemList: [
        {
          title: "账号授权",
          name: ResourceCodeEnums.ACCOUNT_AUTH,
        },
        {
          title: "子账号管理",
          name: ResourceCodeEnums.SUB_ACCOUNT_MANAGEMENT,
        },
        {
          title: "服务协议",
          name: ResourceCodeEnums.AGREEMENT,
          show: true,
        },
      ],
    },
  ],
  [ResourceCodeEnums.CREATE_CROWD]: [
    {
      menuItemList: [
        {
          title: "按标签圈选新建",
          name: ResourceCodeEnums.CUSTOM_LABEL_CREATE,
        },
        {
          title: "上传人群包",
          name: ResourceCodeEnums.UPLOAD_CREATE,
        },
        {
          title: "按智能圈选新建",
          name: ResourceCodeEnums.MODEL_CREATE,
        },
      ],
    },
  ],
  [ResourceCodeEnums.TOOL]: [
    {
      menuItemList: [
        {
          title: "下载中心",
          name: ResourceCodeEnums.DOWNLOAD_CENTER,
        },
        {
          title: "操作记录",
          name: ResourceCodeEnums.OPERATION_LOG,
        },
      ],
    },
  ],
};

export const getMenuItem = (menuName: string) => {
  let ret: MenuItem = undefined;

  Object.keys(navigationMenuGroupMap).forEach(
    (navigationName: ResourceCodeEnums) => {
      const menuGroupList = navigationMenuGroupMap[navigationName];
      menuGroupList.forEach((menuGroup) => {
        ret =
          ret || menuGroup.menuItemList.find((item) => item.name === menuName);
      });
    }
  );

  return ret;
};

export const getMenuItemByChildrenPage = (page: string) => {
  let ret: MenuItem = undefined;

  Object.keys(navigationMenuGroupMap).forEach(
    (navigationName: ResourceCodeEnums) => {
      const menuGroupList = navigationMenuGroupMap[navigationName];
      menuGroupList.forEach((menuGroup) => {
        ret =
          ret ||
          menuGroup.menuItemList.find((item) =>
            item.childrenPage?.includes(page)
          );
      });
    }
  );

  return ret;
};

export const getMenuGroup = (menuName: string) => {
  let ret: MenuGroupItem = undefined;

  Object.keys(navigationMenuGroupMap).forEach(
    (navigationName: ResourceCodeEnums) => {
      const menuGroupList = navigationMenuGroupMap[navigationName];
      menuGroupList.forEach((menuGroup) => {
        if (menuGroup.menuItemList.find((item) => item.name === menuName)) {
          ret = ret || menuGroup;
        }
      });
    }
  );

  return ret;
};

export const getMenuGroupByChildrenPage = (page: string) => {
  let ret: MenuGroupItem = undefined;

  Object.keys(navigationMenuGroupMap).forEach(
    (navigationName: ResourceCodeEnums) => {
      const menuGroupList = navigationMenuGroupMap[navigationName];
      menuGroupList.forEach((menuGroup) => {
        if (
          menuGroup.menuItemList.find((item) =>
            item.childrenPage?.includes(page)
          )
        ) {
          ret = ret || menuGroup;
        }
      });
    }
  );

  return ret;
};
